import React, { useEffect, useRef, useState } from "react";
import { Link } from 'react-router-dom';
import "./services.css";

// Parses "350+" → { num: 350, suffix: "+" }, "4x" → { num: 4, suffix: "x" }
function parseValue(value) {
  const match = value.match(/^(\d+)(.*)$/);
  if (!match) return { num: null, suffix: value };
  return { num: parseInt(match[1], 10), suffix: match[2] };
}

function CountUp({ value }) {
  const { num, suffix } = parseValue(value);
  const [display, setDisplay] = useState(num !== null ? 0 : value);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    if (num === null) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const duration = 1800;
          const steps = 50;
          const increment = num / steps;
          let current = 0;
          const interval = setInterval(() => {
            current += increment;
            if (current >= num) {
              setDisplay(num);
              clearInterval(interval);
            } else {
              setDisplay(Math.floor(current));
            }
          }, duration / steps);
        }
      },
      { threshold: 0.4 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [num]);

  return <span ref={ref}>{display}{suffix}</span>;
}

const ContentPane = ({ title, items, dataPoints, servicesTitle}) => {
  const gridContainerRef = useRef();

  const adjustHeights = () => {
    if (!gridContainerRef.current) return;

    const gridItems = gridContainerRef.current.querySelectorAll(".grid-item");
    let maxHeight = 0;

    gridItems.forEach((item) => {
      item.style.height = "auto";
    });

    gridItems.forEach((item) => {
      const itemHeight = item.scrollHeight;
      if (itemHeight > maxHeight) maxHeight = itemHeight;
    });

    gridItems.forEach((item) => {
      item.style.height = `${maxHeight}px`;
    });
  };

  useEffect(() => {
    adjustHeights();
    window.addEventListener("resize", adjustHeights);
    return () => {
      window.removeEventListener("resize", adjustHeights);
    };
  }, [items]);

  return (
    <div className="content-pane">
      {/* Data Points Section */}
      <div className="data-points-container main-animate" id="why-choose">
        <h2 className="data-points-title">{servicesTitle}</h2>
        <div className="data-points-divider" />
        <div className="data-points-grid">
          {dataPoints.map((point, index) => (
            <div key={index} className="data-point">
              <h3 className="data-point-value"><CountUp value={point.value} /></h3>
              <p className="data-point-label">{point.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="grid-section main-animate">
        <h1 className="grid-title">{title}</h1>
        <div className="grid-title-divider" />
        <div className="grid-container" ref={gridContainerRef}>
          {items.map((item, index) => (
            <div key={index} className="grid-item">
              <div className="item-content">
                <h2 className="item-title">{item.title}</h2>
                <div className="service-line" />
                <p className="item-description">{item.description}</p>
              </div>
              <img
                src={item.icon}
                alt={`${item.title} icon`}
                className="item-icon"
                loading="lazy"
              />
            </div>
          ))}
        </div>
        <div className="grid-cta">
          <p className="grid-cta-text">
            {title.includes('Servicios')
              ? '¿Quieres saber más?'
              : 'Want to know more?'}
          </p>
          <Link to="/services" className="grid-view-all">
            {title.includes('Servicios')
              ? 'Ver todos nuestros servicios aquí →'
              : 'View all of our services here →'}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ContentPane;
